import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const Series = lazy(() => import("../pages/series/page"));
const Archive = lazy(() => import("../pages/archive/page"));
const Collector = lazy(() => import("../pages/collector/page"));
const Admin = lazy(() => import("../pages/admin/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/series",
    element: <Series />,
  },
  {
    path: "/archive",
    element: <Archive />,
  },
  {
    path: "/collector",
    element: <Collector />,
  },
  {
    path: "/admin",
    element: <Admin />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
